<template>
    <div id="app" :class="{chrome:isActive}">
        <router-view :class="$route.name"/>
    </div>
</template>
<script>
export default {
    name: 'App',
    data() {
        return {
            isActive: false
        };
    },
    computed: {},
    components: {},
    created() {
        if (this.$utils.isChrome) {
            this.isActive = true;
        } else {
            this.isActive = false;
        }
    },
    methods: {}
}
</script>
<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%;
}
</style>